







































































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import ALink from '@/components/common/a-link/a-link.vue';
import { PixelItem } from '../types';

const name = 'ttam-promotion-pixel-list-item';
type Status = 'active' | 'inactive';
const defaultMap: Record<Status, string> = {
  active: i18n.t('module_pixel_status_active') as string,
  inactive: i18n.t('module_pixel_status_inactive') as string,
};

export default defineComponent({
  name,
  components: { ALink },
  props: {
    statusMap: {
      type: Object as PropType<Record<Status, string>>,
      default: () => defaultMap,
    },
    source: {
      type: Object as PropType<PixelItem>,
      default: () => ({}),
    },
    onClick: {
      type: Function as PropType<(i: PixelItem) => void>,
      default: () => () => undefined,
    },
    currentItem: {
      type: Object as PropType<PixelItem>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { statusMap, source, currentItem } = toRefs(props);
    const statusText = computed(() => statusMap.value?.[source.value.status] ?? defaultMap.inactive);
    const tipsConfig = computed(() => source.value.tipsConfig);
    const tipsConfigExtra = computed(() => source.value.tipsConfigExtra);
    const isSelectedItem = computed(() => currentItem.value.id === source.value.id);

    return {
      name,
      isSelectedItem,
      statusText,
      tipsConfig,
      tipsConfigExtra,
      onInnerClick: (i: PixelItem) => {
        if (i.disabled) {
          return;
        }
        props?.onClick?.(i);
      },
    };
  },
});
